import type { IconData } from '@stacksjs/iconify-core'

export const web: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"M3 24a21 21 0 1 0 42 0a21 21 0 1 0-42 0\"/><path stroke-linejoin=\"round\" d=\"M15 24a9 21 0 1 1 18 0a9 21 0 1 1-18 0\"/><path stroke-linecap=\"round\" d=\"M4.5 31h39m-39-14h39\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default web
